import { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/utils/tailwind';

type ModalFooterProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  className?: string;
};
const ModalFooter = ({ children, className, ...props }: ModalFooterProps) => (
  <div className={cn('p-4 border-t border-border', className)} {...props}>
    {children}
  </div>
);

export { ModalFooter };
